<div class="log" #scroller (scroll)="onScroll()">
  <ng-container *ngFor="let message of messages; trackBy: trackMessage">

    <!-- Milestone banner — inline, never a modal, collapses to one line after 4s. -->
    <div
      *ngIf="message.variant === 'milestone'; else standard"
      class="log__milestone"
      [class.log__milestone--collapsed]="message.collapsed"
      role="status"
    >
      <span class="log__milestone-glyph" aria-hidden="true">★</span>
      <span class="log__milestone-text">{{ message.text }}</span>
    </div>

    <ng-template #standard>
      <!-- System line. -->
      <div *ngIf="message.role === 'system'" class="log__system">{{ message.text }}</div>

      <!-- User turn. -->
      <div *ngIf="message.role === 'user'" class="log__row log__row--user">
        <div class="log__bubble log__bubble--user" [innerHTML]="message.text | buddyMarkdown"></div>
      </div>

      <!-- Assistant turn: bubble, optional workflow card, TTS chip, reward chip, replies. -->
      <div *ngIf="message.role === 'assistant'" class="log__row log__row--bb">
        <div class="log__bubble log__bubble--bb">
          <!-- While the reply is still on its way the bubble has no text yet:
               show a "BB is thinking" label with bouncing dots (WhatsApp-style),
               so the multi-second wait never looks frozen. -->
          <span
            *ngIf="message.streaming && !message.text"
            class="log__typing"
            role="status"
            aria-label="BB is thinking"
          >
            <span class="log__typing-label">BB is thinking</span>
            <span class="log__typing-dots" aria-hidden="true">
              <span></span><span></span><span></span>
            </span>
          </span>
          <!-- The answer: the backend returns ready-to-render HTML, bound directly.
               Angular's default sanitizer keeps safe tags (p/strong/table/li/a/…) and
               strips scripts, so no bypass and no client markdown parsing. Rendered whole
               once it arrives — HTML is NOT token-streamed (partial HTML breaks tags). -->
          <div
            *ngIf="message.text || !message.streaming"
            class="log__html"
            [innerHTML]="message.text"
          ></div>
        </div>

        <app-buddy-workflow-card
          *ngIf="runFor(message) as run"
          [run]="run"
          (cancelled)="cancelRun.emit($event)"
          (retried)="retryRun.emit($event)"
          (decided)="decideRun.emit($event)"
        ></app-buddy-workflow-card>

        <app-buddy-tts-chip
          *ngIf="speakingMessageId === message.id"
          [rate]="ttsRate"
          (stopped)="stopTts.emit()"
        ></app-buddy-tts-chip>

        <!--
          Ephemeral by design: floats and fades over 2.5s and does not persist as
          chrome. The visually-hidden status alongside it means the reward is still
          announced as text, so colour and motion never carry it alone.
        -->
        <ng-container *ngIf="message.reward as reward">
          <span class="log__reward" [class.log__reward--bonus]="reward.bonus" aria-hidden="true">
            {{ rewardLabel(reward) }}
          </span>
          <span class="log__sr" role="status">{{ rewardLabel(reward) }} earned for {{ reward.label }}</span>
        </ng-container>

        <div class="log__replies" *ngIf="message.actions.length">
          <button
            type="button"
            class="log__reply"
            *ngFor="let action of message.actions"
            [class.log__reply--primary]="action.primary"
            (click)="suggestionPicked.emit(action.label)"
          >
            {{ action.label }}
          </button>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>
